"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIntlMessage = exports.getTranslationValue = exports.replaceKeysWithValues = void 0;
var replaceKeysWithValues = function (obj, messages) {
    var newObj = JSON.stringify(obj);
    newObj = JSON.parse(newObj, function (key, value) {
        return typeof value === 'string' ? (0, exports.getTranslationValue)(value, messages) : value;
    });
    return newObj;
};
exports.replaceKeysWithValues = replaceKeysWithValues;
var getTranslationValue = function (text, messages) {
    var newStr = text;
    var regKeys = /^{{.*?}}$/g;
    var match = regKeys.exec(text);
    if (match) {
        var key = match[0].replace(/[{{|}}]+/g, '');
        var translatedStr = (0, exports.getIntlMessage)(messages, key);
        newStr = text.replace(match[0], translatedStr);
    }
    return newStr;
};
exports.getTranslationValue = getTranslationValue;
var getIntlMessage = function (messages, key, noErrorOnMissingKey) {
    if (key === '')
        return key;
    var value = messages[key];
    if (value)
        return value;
    if (noErrorOnMissingKey || process.env.NODE_ENV === 'development')
        return key;
    throw Error("Missing translation for key: ".concat(key));
};
exports.getIntlMessage = getIntlMessage;
